import React from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Field, Form as FORM, Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-multi-lang";
import {
  agentCreateStart,
  agentUpdateStart,
} from "../../store/slices/AgentSlice";
import { ButtonLoader } from "../Helper/Loader";

const AgentFormModal = ({ show, onHide, agent }) => {
  const dispatch = useDispatch();
  const t = useTranslation("agent_form");
  const isUpdate = !!agent;
  const agentCreate = useSelector((state) => state.agent.agentCreate);
  const agentUpdate = useSelector((state) => state.agent.agentUpdate);
  const submittingState = isUpdate ? agentUpdate : agentCreate;

  const validationSchema = Yup.object().shape({
    name: Yup.string().required(t("name.required")),
    email: Yup.string()
      .email(t("email.invalid"))
      .required(t("email.required")),
  });

  const permissionKeys = [
    "payin",
    "payout",
    "withdraw",
    "deposit",
    "payin_wallet",
    "payout_wallet",
  ];

  const initialValues = {
    name: agent?.name || "",
    email: agent?.email || "",
    payin: !!agent?.configuration?.payin,
    payout: !!agent?.configuration?.payout,
    withdraw: !!agent?.configuration?.withdraw,
    deposit: !!agent?.configuration?.deposit,
    payin_wallet: !!agent?.configuration?.payin_wallet,
    payout_wallet: !!agent?.configuration?.payout_wallet,
  };

  const handleSubmit = (values) => {
    const payload = {
      name: values.name,
      email: values.email,
      payin: !!values.payin ? 1 : 0,
      payout: !!values.payout ? 1 : 0,
      withdraw: !!values.withdraw ? 1 : 0,
      deposit: !!values.deposit ? 1 : 0,
      payin_wallet: !!values.payin_wallet ? 1 : 0,
      payout_wallet: !!values.payout_wallet ? 1 : 0,
    };

    if (isUpdate) {
      payload.merchant_agent_id = agent.id;
      dispatch(agentUpdateStart(payload));
    } else {
      dispatch(agentCreateStart(payload));
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {isUpdate ? t("title_update") : t("title_create")}
        </Modal.Title>
      </Modal.Header>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, setFieldValue }) => (
          <FORM>
            <Modal.Body>
              <Row className="g-3">
                <Col md={6}>
                  <div className="form-group">
                    <label className="form-label">{t("name.label")}</label>
                    <Field
                      name="name"
                      placeholder={t("name.placeholder")}
                      type="text"
                      className="form-control"
                    />
                    <ErrorMessage
                      name="name"
                      component="div"
                      className="text-danger small mt-1"
                    />
                  </div>
                </Col>
                <Col md={6}>
                  <div className="form-group">
                    <label className="form-label">{t("email.label")}</label>
                    <Field
                      name="email"
                      placeholder={t("email.placeholder")}
                      type="email"
                      className="form-control"
                    />
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="text-danger small mt-1"
                    />
                  </div>
                </Col>
                <Col xs={12}>
                  <p className="mb-2 fw-semibold">
                    {t("permissions.title")}
                  </p>
                  <div className="d-flex flex-wrap gap-3">
                    {permissionKeys.map((key) => (
                      <Form.Check
                        key={key}
                        type="switch"
                        id={`agent-${key}`}
                        label={t(`permissions.${key}`)}
                        checked={!!values[key]}
                        onChange={() => setFieldValue(key, !values[key])}
                      />
                    ))}
                  </div>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="outline-secondary" onClick={onHide}>
                {t("cancel")}
              </Button>
              <Button
                type="submit"
                className="snapgopay-payment-btn"
                disabled={submittingState.buttonDisable}
              >
                {submittingState.buttonDisable ? (
                  <ButtonLoader />
                ) : isUpdate ? (
                  t("update")
                ) : (
                  t("save")
                )}
              </Button>
            </Modal.Footer>
          </FORM>
        )}
      </Formik>
    </Modal>
  );
};

export default AgentFormModal;
